
const tiposCarroceria = [
  { id: 'Cavaqueira', nome: 'Cavaqueira' },
  { id: 'Tanque', nome: 'Tanque' },
  { id: 'Gaiola', nome: 'Gaiola' },
  { id: 'Cegonheiro', nome: 'Cegonheiro' },
  { id: 'Apenas_Cavalo', nome: 'Apenas Cavalo' },
  { id: 'Prancha', nome: 'Prancha' },
  { id: 'Baú_Frigorífico_ou_Refrigerado', nome: 'Baú Frigorífico' },
  { id: 'Grade_Baixa', nome: 'Grade Baixa' },
  { id: 'Caçamba_Basculante', nome: 'Caçamba' },
  { id: 'Graneleiro_ou_Grade_alta', nome: 'Graneleiro' },
  { id: 'Sider', nome: 'Sider' },
  { id: 'Baú', nome: 'Baú' },
  { id: 'Munk', nome: 'Munk' },
  { id: 'Silo', nome: 'Silo' },
  { id: 'Bug_porta_container', nome: 'Bug Porta Container' }
]

export default tiposCarroceria



// WEBPACK FOOTER //
// ./src/vuex/cache/tiposCarroceria.js